import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import SalesStreamHeader from '../Header';
import SalesStreamFilters from './filters';
import SalesStreamNavBarOpen from '../../../images/sales-stream/sales-stream-panel-open.svg';
import SalesStreamNavBarClose from '../../../images/sales-stream/sales-stream-panel-close.svg';
import { checkIfFilterAvailable } from '../../../helpers/sales-stream';
import SalesStreamSummary from '../components/Summary';

const useStyles = makeStyles({
  panel: {
    marginTop: '5px',
    position: 'fixed',
    left: 0,
    height: '98%',
    width: '245px',
    color: '#fff',
    transform: 'translateX(-100%)',
    transition: 'transform 0.3s ease-in-out', // Smooth transition
  },
  panelOpen: {
    transform: 'translateX(0)', // Moves the panel into view
  },
  icon: {
    padding: '0px',
    marginLeft: '-17px',
    marginBottom: '-40px',
  },
  panelButtonIconOpen: {
    padding: '0px',
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'start',
    borderRight: '1px solid #33353B',
    height: '90%',
    width: '90%',
  },
});

const SalesStreamPanel = ({
  isOpen,
  togglePanel,
  handleFilterChange,
  filterValue,
  summaryData,
  setSummaryData,
  detailsData,
  setDetailsData,
  cotaAtFloorPercentage,
  onCotaAtFloorPercentageChange,
}) => {
  const isFilterByVisible = checkIfFilterAvailable();
  const classes = useStyles();

  const iconButton = (
    <IconButton onClick={() => togglePanel()} className={`${isOpen ? classes.iconOpen : classes.icon}`}>
      {isOpen ? (
        <img
          src={SalesStreamNavBarClose}
          className={`${isOpen ? classes.panelButtonOpen : ''}`}
          alt="Logo"
          style={{ height: '30px' }}
        />
      ) : (
        <img src={SalesStreamNavBarOpen} alt="Logo" style={{ height: '30px' }} />
      )}
    </IconButton>
  );

  if (isOpen) {
    return (
      <div>
        {/* Sliding Panel */}
        <div className={`${classes.panel} ${isOpen ? classes.panelOpen : ''}`}>
          <SalesStreamHeader />
          <div style={{ display: 'flex', justifyContent: 'end' }}>{iconButton}</div>
          <div className={classes.panelButtonIconOpen}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <SalesStreamFilters
                  isFilterByVisible={isFilterByVisible}
                  handleFilterChange={handleFilterChange}
                  cotaAtFloorPercentage={cotaAtFloorPercentage}
                  onCotaAtFloorPercentageChange={onCotaAtFloorPercentageChange}
                  filterValue={filterValue}
                />
              </Grid>
              <Grid item xs={12}>
                <SalesStreamSummary
                  filterValue={filterValue}
                  summaryData={summaryData}
                  setSummaryData={setSummaryData}
                  detailsData={detailsData}
                  setDetailsData={setDetailsData}
                />
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    );
  }

  return <div className={classes.panelButtonIcon}>{iconButton}</div>;
};

SalesStreamPanel.defaultProps = {
  filterValue: null,
  summaryData: {},
  setSummaryData: undefined,
  detailsData: {},
  setDetailsData: undefined,
  cotaAtFloorPercentage: null,
};

SalesStreamPanel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  togglePanel: PropTypes.func.isRequired,
  handleFilterChange: PropTypes.func.isRequired,
  filterValue: PropTypes.array,
  summaryData: PropTypes.object,
  setSummaryData: PropTypes.func,
  detailsData: PropTypes.object,
  setDetailsData: PropTypes.func,
  cotaAtFloorPercentage: PropTypes.number,
  onCotaAtFloorPercentageChange: PropTypes.func.isRequired,
};

export default SalesStreamPanel;
